import BrandLogo from '@components/v2/ui/BrandLogo/BrandLogo';
import Button from '@components/v2/ui/Button/Button';
import { AppBar, Divider, Grid, Toolbar } from '@mui/material';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AboutInfo } from '../../components/Site/AboutSection';
import LangEnum from '../../lang/LangEnum';
import { getAuthLoginPath } from '../../routes/auth.routes';
import { APP_BAR_ID } from '../../routes/routes-page.styles';
import { BrandLogos } from '../../services/modules/brand/brand.types';
import ConnectAccountModal from '../login/ConnectAccountModal';
import { useTranslation } from '../translation/TranslationContext';

type BrandShowroomProps = {
  data: Partial<AboutInfo>;
  slug: string;
  logos?: BrandLogos;
};

const PublicBrandShowroomHeader = ({ data, slug, logos }: BrandShowroomProps) => {
  const { translate } = useTranslation();
  const [isConnectAccountModalOpen, setIsConnectAccountModalOpen] = useState(false);
  const { search } = useLocation();

  return (
    <>
      <AppBar id={APP_BAR_ID} elevation={0} color="inherit" position="fixed">
        <Toolbar>
          <Grid
            container
            spacing={1}
            sx={{
              alignItems: 'center',
            }}
            size="grow"
          >
            <Grid size="grow">
              <Grid
                container
                spacing={2}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid size="grow">
                  <BrandLogo name={data?.name} logos={{ ...logos, squaredLogo: data?.logoUrl }} />
                </Grid>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    alignItems: 'center',
                  }}
                >
                  <Grid>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => setIsConnectAccountModalOpen(true)}
                    >
                      {translate(LangEnum.MY_NETWORK_SUGGESTIONS_LIST_CONNECT)}
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      to={getAuthLoginPath(slug, search)}
                    >
                      {translate(LangEnum.LOGIN_LOGIN)}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
        <Divider />
      </AppBar>
      <ConnectAccountModal
        open={isConnectAccountModalOpen}
        onClose={() => setIsConnectAccountModalOpen(false)}
        brandSlug={slug}
      />
    </>
  );
};
export default PublicBrandShowroomHeader;
